<section class="hero-banner">
  <h1>Bienvenido a nuestra tienda</h1>
  <p>Explora nuestros productos exclusivos</p>
  <button class="btn">Ver más</button>
</section>
